



































































/* General */
import Vue from 'vue'

/* Mixins */

/* Components */

/* Helpers */
import ColorAssistant from '@/helpers/color-assistant'

/* Data types */
import { IConvoForForwardingVerification } from '@/api/types/response.types'

/* API */
import MailboxesAPI from '@/api/modules/mailboxes.api'

export default Vue.extend({
  metaInfo: {
    title: 'Verify auto-forwarding address',
  },

  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      ColorAssistant,
      pollingForVerification: true,
      hasVerificationEmails: false,
      poller: null,
      pollCount: 0,
      pollIntervalInMS: 5000,
      pollMax: 12,
      recentCustomerConvos: [] as IConvoForForwardingVerification[],
    }
  },

  computed: {
    internalShowModal: {
      get(): Boolean {
        return this.showModal
      },
      set(value: any): any {
        this.$emit('update:showModal', value)
      },
    },
    mailboxID(): number {
      return Number(this.$route.params.id)
    },
    title(): string {
      if (this.pollingForVerification) {
        return 'Searching for an email...'
      } else if (this.hasVerificationEmails) {
        if (this.recentCustomerConvos.length > 1) {
          return `We found ${this.recentCustomerConvos.length} recent emails!`
        }
        return 'Email found!'
      } else {
        return 'No email found'
      }
    },
    subtitle(): string {
      if (this.pollingForVerification) {
        return ''
      } else if (this.hasVerificationEmails) {
        if (this.recentCustomerConvos.length > 1) {
          return 'Find the one about auto-forwarding and follow the instructions.'
        }
        return 'Follow the instructions below before closing the window.'
      }
    },
    verificationEmailNotFound(): boolean {
      return !this.hasVerificationEmails && !this.pollingForVerification
    },
  },

  watch: {
    pollCount: {
      handler(newValue) {
        if (newValue >= this.pollMax) {
          this.endPolling()
        }
      },
    },
  },

  beforeDestroy() {
    this.endPolling()
  },

  async created() {
    this.pollForVerificationEmail()
  },

  methods: {
    endPolling() {
      clearInterval(this.poller)
      this.pollingForVerification = false
    },
    pollForVerificationEmail() {
      this.hasVerificationEmails = false
      this.pollingForVerification = true
      this.pollCount = 0
      this.poller = setInterval(async () => {
        this.pollCount++
        await this.getMostRecentCustomerCreatedConvos()
      }, this.pollIntervalInMS)
    },
    async getMostRecentCustomerCreatedConvos() {
      try {
        this.recentCustomerConvos = await MailboxesAPI.get_MostRecentCustomerCreatedConvoForForwardingVerifications(
          this.mailboxID,
        )
        this.hasVerificationEmails = true
        this.endPolling()
      } catch (err) {
        console.log('No verification email found.')
      }
    },
  },
})
